export const environment = {
  production: false,
  link: 'https://www-stage-purdueglobal.mkt.kaplan.com/',
  name: 'stage environment',
  Contentful: {
    BasePath: 'https://graphql.contentful.com/content/v1/spaces/',
    Space: 'btf5tt6k5y9e',
    AccessToken: 'd1Asc7QZRPb3ic9za8GmlwEDLXuwRMEuLED66CDUSiM',
    PreviewToken: 'hRZVUK3vMPA34bKnFMY1FU8_bt_5nRLo0EXoDih2ur4',
    environment: 'Stage'
  },
  Genesys: {
    src: 'https://storage.googleapis.com/kna-gen-widgets-stg/lib/cxbus.min.js',
    pluginsPath: 'https://storage.googleapis.com/kna-gen-widgets-stg/lib/plugins/',
    loadFile: 'https://storage.googleapis.com/kna-gen-widgets-stg/pg_pre.widgets.min.js',
    env: 'STG',
    cdnUrl: 'https://storage.googleapis.com/kna-genesys-cloud-widget-stg/scripts/genesys-latest.min.js'
  },
  Ycbm: {
    src: 'https://embed.youcanbook.me',
    path: 'purdueglobalpreenrollment-stage'
  },
  APIBasePath: '',
  SiteSearch360: {
    configurationId: '49562'
  },
  Recaptcha: {
    PublicKey: '6LdP23cqAAAAAJJDQ16gz0qU-GV6XFVlrmg-t06u',
    ChallengePublicKey: '6Lc2kHcqAAAAAPWF0Z3dCVwA-vDf8Ux6C4BLQ15R'
  },
  Ninetailed: {
    ClientId: '27f17712-600d-4180-adb2-d4cac768b4fc',
    Environment: 'he-development'
  }
};
